import { render, staticRenderFns } from "./CobranzaCrud.vue?vue&type=template&id=d3055482"
import script from "./CobranzaCrud.vue?vue&type=script&lang=js"
export * from "./CobranzaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports